module.exports = __webpack_public_path__ + "img/warning_cart.54de0c4a.png";